import { createClient } from '@/shared/api';
import type {
  UpdateStudyPatientInformationMutation,
  UpdateStudyPatientInformationMutationVariables,
} from '@/shared/api';
import UPDATE_STUDY_PATIENT_INFORMATION from '../mutations/updateStudyPatientInformation';

/**
 * Saves the patient's demographic information on a study. Runs UPDATE_STUDY_PATIENT_INFORMATION and throws the returned message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns The updateStudyPatientInformation payload.
 */
const handleUpdateStudyPatientInformation = async (
  input: UpdateStudyPatientInformationMutationVariables['input'],
): Promise<UpdateStudyPatientInformationMutation['updateStudyPatientInformation']> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateStudyPatientInformationMutation,
    UpdateStudyPatientInformationMutationVariables
  >({
    mutation: UPDATE_STUDY_PATIENT_INFORMATION,
    variables: { input },
  });
  const { data } = result;
  const { updateStudyPatientInformation } = data ?? {};
  if (!updateStudyPatientInformation?.isSuccess) {
    throw new Error(updateStudyPatientInformation?.message ?? undefined);
  }
  return updateStudyPatientInformation;
};

export default handleUpdateStudyPatientInformation;
